import { handleActions } from "redux-actions";
import {
  setSiteUsers,
  setSiteUsersLoading,
  setSiteUsersError,
  setSiteRoles,
  setSiteRolesLoading,
  setSiteRolesError,
  updateSiteUser
} from "../../../../actions";

const defaultState = {
  items: [],
  loading: false,
  error: null,
  siteRoles: [],
  siteRolesLoading: false,
  siteRolesError: null,
};

export default handleActions(
  {
    [setSiteUsers]: (state, { payload }) => {
      const { items } = payload;
      return {
        ...state,
        items,
      };
    },
    [setSiteUsersLoading]: (state, { payload }) => {
      const { loading } = payload;
      return {
        ...state,
        loading,
      };
    },
    [setSiteUsersError]: (state, { payload }) => {
      const { error } = payload;
      return {
        ...state,
        error,
      };
    },
    [setSiteRoles]: (state, { payload }) => {
      const { items } = payload;
      return {
        ...state,
        siteRoles: items,
      };
    },
    [setSiteRolesLoading]: (state, { payload }) => {
      const { loading } = payload;
      return {
        ...state,
        loading,
      };
    },
    [setSiteRolesError]: (state, { payload }) => {
      const { error } = payload;
      return {
        ...state,
        error,
      };
    },
    [updateSiteUser]: (state, { payload }) => {
      const { updatedUser } = payload;

      return {
        ...state,
        items: state.items.map(u =>
          u.id === updatedUser.id ? { ...u, ...updatedUser } : u
        ),
      };
    },
  },
  defaultState
);
